module.exports = __webpack_public_path__ + "static/img/Banner_mobile_nino_redpie.6deba9d6.svg";